
import { List, Card, Space } from "antd";
import React from "react";
import { data } from "react-router-dom";


const pricingCategory = {
  "adult": "Adult",
  "child_no_bed": "Child no bed",
  "child_twin": "Child twin",
  "child_with_bed": "Child with bed",
  "infant": "Infant",
  "single_supplement": "Single Supplement",
  // "dta_adult": "DTA Adult",
  // "dta_child_no_bed": "DTA Child no bed",
  // "dta_child_twin": "DTA Child twin",
  // "dta_child_with_bed": "DTA Child with bed",
  // "dta_infant": "DTA Infant",
  // "dta_single_supplement": "DTA Single Supplement",
};

const priceTypes = {
  "normal": "normal",
  "normal1": "normal 1",
  "normal2": "normal 2",
  "normal3": "normal 3",
  "normal4": "normal 4",
  "normal5": "normal 5",
  "normal6": "normal 6",
  "normal7": "normal 7",
  "normal8": "normal 8",
  "normal9": "normal 9",
  "early_bird": "early bird",
  "specialoffer": "special offer",
  "specialdeal": "special deal",
  "superpromo": "super promo",
  "promo": "promo",
  "promo1": "promo 1",
  "promo2": "promo 2",
  "promo3": "promo 3",
}


const PriceDetails = (
  props: {
    priceCurrency:string,
    prices: any[]
  }
) => {
  const { priceCurrency, prices } = props;
  
  var pricingTypes:any[] = [], priceTable:any = {}, priceList:any[] = [];
  if(prices.length>0){
    pricingTypes = prices.map((price:any) => price.type);
    prices.forEach((price:any) => {
      const pricingObj = {
        label: price.display_price,
        adult: price.adult,
        child_no_bed: price.child_no_bed,
        child_twin: price.child_twin,
        child_with_bed: price.child_with_bed,
        dta_adult: price.dta_adult,
        dta_child_no_bed: price.dta_child_no_bed,
        dta_child_twin: price.dta_child_twin,
        dta_child_with_bed: price.dta_child_with_bed,
        dta_infant: price.dta_infant,
        dta_single_supplement: price.dta_single_supplement,
        infant: price.infant,
        single_supplement: price.single_supplement,
      };

      priceTable[price.type] = pricingObj;

      priceList.push({
        title: `${price.display_price} ${priceTypes[price.type]}`,
        type: price.type,
        ...pricingObj
      })
    });
  }

  return (
    <div id="price-details" className="details-container">
      <div className="details-container_header"> Price Details </div>
      <div className="details-container_content">
        <table id="pricing-table">
          <thead>
            <tr>
              <th></th>
              {
                pricingTypes.map((type:any) => <th className={type}>
                  <div>{priceTable[type].label}</div>
                  <div className="price-type">{priceTypes[type]}</div>
                </th>)
              }
            </tr>
          </thead>
          <tbody>
            {
              Object.entries(pricingCategory).map(category => (
                <tr>
                  <td> {category[1]}  </td>
                  {
                    pricingTypes.map((type:any) => <td className={type}> {priceCurrency} {priceTable[type][category[0]]}</td>)
                  }
                </tr>
              ))
            }
          </tbody>
        </table>

        {
          priceList.length > 0 && (
            <List
              id="pricing-list"
              itemLayout="vertical"
              dataSource={priceList}
              renderItem={(item) => (
                <List.Item>
                  <Card className={item.type}>
                    <div className="pricing-header"> {item.title} </div>
                    <div className="pricing-body"> 
                      <Space size={15} direction="vertical" style={{display: 'flex'}}>
                        {
                          Object.entries(pricingCategory).map(category => (
                            <div className="pricing"> 
                              <div className="category"> {category[1]} </div>
                              <div className="price">{priceCurrency} {item[category[0]]} </div>
                            </div>
                          ))
                        }
                      </Space>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          )
        }

      </div>
    </div>
  )
}

export default PriceDetails;